import styled from 'styled-components'
import theme from '@app/ui/theme'
import { TeeCard } from '@app/components/molecules/TeeColorPicker/styled'

// The tee cards on the preparation page, with the one thing they do not have
// to do: open the tee for editing.
export const TeeCardButton = styled(TeeCard)`
  cursor: pointer;
  &:hover {
    border-color: ${theme.colors.secondary2};
  }
`

// The colour block the picker shows, as something to look at rather than to
// edit: the colour is changed in the tee overlay.
export const TeeSwatch = styled.div<{ color?: string }>`
  width: 100%;
  height: 32px;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  background-color: ${({ color }) => color || theme.colors.white};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
`

export const TeeName = styled.div`
  font-weight: 700;
  line-height: 18px;
  color: #282828;
  overflow-wrap: anywhere;
`

export const TeeRating = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 6px;
  font-size: ${theme.fontSize[0]}px;
  line-height: 16px;
  color: #666;
  /* Doubled up on purpose: the form row these cards sit in styles every span
     it contains, and this has to be the rule that wins. */
  && > span {
    font-size: ${theme.fontSize[0]}px;
    font-weight: 600;
    line-height: 16px;
    color: ${theme.colors.black};
  }
`
